import { Action } from 'redux';

export const START_SCD_NEW_FILL_TUTORIAL = 'START_SCD_NEW_FILL_TUTORIAL';

/**
 * startSCDNewFillTutorial is an action that is dispatched to start the SCD New Fill tutorial
 *
 * @param taskItemId - the task item to display the tutorial on
 */
export const startSCDNewFillTutorial = (
    taskItemId: string,
): Action<typeof START_SCD_NEW_FILL_TUTORIAL> & {
    taskItemId: string;
} => ({ type: START_SCD_NEW_FILL_TUTORIAL, taskItemId });
